import html from './template.html'

const template = document.createElement('template')
template.innerHTML = html

/**
 * Banner element that responds on the scrolling of the document.
 * @extends	HTMLElement
 */

class GalleryOverlay extends HTMLElement {
    static get observedAttributes() {
        return ['open']
    }

    /**
     * The name of the tag to create.
     * @returns {string}
     */
    static get tagName() {
        return 'gallery-overlay'
    }

    constructor() {
        super()

        const forEachElement = element => {
            element.addEventListener('click', () => {
                this.open = false
            })
        }

        this.attachShadow({ mode: 'open' })
        this.shadowRoot.append(template.content.cloneNode(true))

        this.shadowRoot.addEventListener('slotchange', event => {
            const { target } = event
            const { name } = target

            if (name === 'close') {
                const elements = target.assignedElements()
                elements.forEach(forEachElement)
            }
        })

        this._onKeyDown = this._onKeyDown.bind(this)
    }

    /**
     * Gets and sets the open attribute value.
     * @property
     */
    get open() {
        return this.hasAttribute('open')
    }

    set open(value) {
        if (value === true) {
            this.setAttribute('open', '')
        } else {
            this.removeAttribute('open')
        }
    }

    /**
     * Dispatch a change event whenever the open attribute value changes.
     */
    attributeChangedCallback() {
        this.dispatchEvent(
            new CustomEvent('galleryoverlaychange', {
                bubbles: true,
                detail: {
                    isOpen: this.open,
                },
            })
        )
    }

    /**
     * Listen to the keydown event.
     */
    connectedCallback() {
        document.addEventListener('keydown', this._onKeyDown)
    }

    /**
     * Remove the keydown event listener.
     */
    disconnectedCallback() {
        document.removeEventListener('keydown', this._onKeyDown)
    }

    /**
     * Keydown event that closes modal when the escape key is pressed.
     * @param {Event} event
     */
    _onKeyDown(event) {
        const escKeyCode = 27
        const { keyCode } = event

        if (keyCode == escKeyCode && this.open) {
            this.open = false
            event.preventDefault()
        }
    }
}

customElements.define(GalleryOverlay.tagName, GalleryOverlay)



// WEBPACK FOOTER //
// ./scripts/web-components/gallery-overlay/index.js